import { gql } from 'graphql-tag'

import { orderFieldsCWA } from './orderFieldsCWA'

/**
 * CWA's order lookup. Resolves through `getOrderByTrackingIdCWA`, always
 * suppresses pickups, and takes `includeConsumerSupportCases` — none of which
 * the shared `GET_ORDER_BY_TRACKING_ID` does.
 */
export const GET_ORDER_BY_TRACKING_ID_CWA = gql`
  query getOrderByTrackingIdCWA($trackingId: String!, $includeConsumerSupportCases: Boolean!) {
    order: getOrderByTrackingIdCWA(
      trackingId: $trackingId
      includePickups: false
      includeConsumerSupportCases: $includeConsumerSupportCases
    ) {
      ...OrderFieldsCWA
    }
  }
  ${orderFieldsCWA}
`
